export const attributeModelOptions = (t, { includeCompanies = false } = {}) => [
  {
    value: 0,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_MODELS.CONVERSATION'),
  },
  {
    value: 1,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_MODELS.CONTACT'),
  },
  ...(includeCompanies
    ? [
        {
          value: 2,
          label: t('ATTRIBUTES_MGMT.ATTRIBUTE_MODELS.COMPANY'),
        },
      ]
    : []),
];

export const attributeTypeOptions = t => [
  {
    value: 0,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.TEXT'),
    key: 'TEXT',
  },
  {
    value: 1,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.NUMBER'),
    key: 'NUMBER',
  },
  {
    value: 4,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.LINK'),
    key: 'LINK',
  },
  {
    value: 5,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.DATE'),
    key: 'DATE',
  },
  {
    value: 6,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.LIST'),
    key: 'LIST',
  },
  {
    value: 7,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.CHECKBOX'),
    key: 'CHECKBOX',
  },
  {
    value: 8,
    label: t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.MEMO'),
    key: 'MEMO',
  },
];
